import { render, staticRenderFns } from "./VpnLog.vue?vue&type=template&id=f1671446&scoped=true"
import script from "./VpnLog.vue?vue&type=script&lang=js"
export * from "./VpnLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1671446",
  null
  
)

export default component.exports